import uiCore = require("../../core/uicore");
import dataCore = require("../../core/datacore");
import entityCache = require("../../core/entitycache");
import entityHelper = require("../../core/entityhelper");

export interface IPersonRoleStateParams {
    personRoleId: number;
    personId: number;
}

export class PersonRoleStateStrings {
    public static List = "resources.persons.detail";
    public static Details = "resourcespersonsroletitlesdetails";
    public static New = "resourcespersonsroletitlesnew";
    public static Edit = "resourcespersonsroletitlesdetailsedit";
}

class PersonRoleBase  implements uiCore.IDirective {

    public personRole: Nema.Crew.Model.PersonRole;
    protected dataCache: entityCache.EntityCache;
    private _locator: uiCore.DependencyLocator;
    private _changesResolved: boolean;
    private _isNew: boolean;
    private _state: IPersonRoleStateParams;

    public static BaseAngularDependencies: uiCore.IAngularDependencyId[] = [uiCore.ScopeDependency, uiCore.StateParamsDependency, uiCore.StateDependency, uiCore.MdDialogDependency];

    constructor(isNew: boolean, onDataLoaded: () => void, component: uiCore.IComponentWithDescription, injected: any[]) {
        this._changesResolved = false;
        this._isNew = isNew;
        this._locator = uiCore.DependencyLocator.Create(component, injected);
        this._state = <IPersonRoleStateParams><any>this._locator.getStateParamsDependency();
        this.dataCache = new entityCache.EntityCache(entityCache.CommonEntityManagers.EntityManager);
        var dataDependencies: string[] = [
            entityCache.EntityTypeNames.Person,
            entityCache.EntityTypeNames.RoleType,
            entityCache.EntityTypeNames.PersonRole,
        ];
        var entitiesPromise = this.dataCache.getEntitySetsPromise(dataDependencies);
        var self = this;

        entitiesPromise.then(res => {
            this.initializedata(isNew, res);
            if (onDataLoaded) {
                onDataLoaded();
            }
            self._locator.getScopeDependency().$apply();
        }).catch(_reason => {
        });
    }

    protected initializedata(isNew: boolean, _res: entityCache.EntitySetDictionary) {
        if (isNew) {
            var person = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.Person, this._state.personId);
            if (!person) return;
            var newPersonRole = <Nema.Crew.Model.PersonRole> { Person: person, From: dataCore.getToday(), To: dataCore.DateMaxInfinity };
            this.personRole = <any>this.dataCache.entityManager.createEntity(entityCache.EntityTypeNames.PersonRole, newPersonRole);
        }
        else {
            this.personRole = <any>this.dataCache.getEntity(entityCache.EntityTypeNames.PersonRole, this._state.personRoleId);
        }
    }

    public querySearchRoleType(searchString: string): Nema.Crew.Model.RoleType[] {
        return <any[]> this.dataCache.searchActiveByName(entityCache.EntityTypeNames.RoleType, searchString);
    }

    public delete() {

        var listOfChanges = [
            () => { (<breeze.Entity><any>this.personRole).entityAspect.setDeleted(); }
        ];

        this.personRole.Person;

        entityHelper
            .confirmedSaveSequentialListOfChangesAndNavigate(
            listOfChanges,
            "Delete Person Role",
            "Please confirm to delete Person Role",
            this.dataCache.entityManager,
            this._locator.getMdDialogDependency(),
            () => { this.goToList() },
            this._locator.getStateDependency());
    }

    public edit() {
        this._locator.getStateDependency().go("app." + PersonRoleStateStrings.Edit, <IPersonRoleStateParams>{ personRoleId:this.personRole.Id });
    }

    public cancel() {
        this._changesResolved = true;
        this.dataCache.entityManager.rejectChanges();
        if (this._isNew) {
            this.goToList();
        }
        else {
            this.goToDetails();
        }
    }

    protected goToList = () => {
        this._locator
            .getStateDependency()
            .go("app." + PersonRoleStateStrings.List, { personId: this.personRole.PersonId });
    }

    protected goToDetails = () => {
        this._locator.getStateDependency().go("app." + PersonRoleStateStrings.Details, <IPersonRoleStateParams> { personRoleId: this.personRole.Id });
    }

    //private goToNew() {
    //    this._locator
    //        .getStateDependency()
    //        .go("app." + PersonRoleStateStrings.New, <IPersonRoleStateParams> { personId: this._state.personId });
    //}

    public save() {
        var listOfChanges = [
            () => { },
        ];
        this._changesResolved = true;
        entityHelper.saveSequentialListOfChangesAndNavigate(listOfChanges, this.dataCache.entityManager, this.goToDetails, this._locator.getStateDependency());
    }

    public hasChanges() {
        if (this._changesResolved) return false;
        if (this._isNew) return true;
        if (this.dataCache.entityManager.hasChanges()) return true;
        return false;
    }
}

export class PersonRoleDetails extends PersonRoleBase {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonRoleStateStrings.Details,
        Url: "/resources/personrole/{personRoleId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Roles",
        StateString: PersonRoleStateStrings.Details,
        Template: require("./personrole.details.html"),
        AngularDependencies: PersonRoleBase.BaseAngularDependencies
    }

    constructor(...args: any[]) {
        super(false,() => {
        }, PersonRoleDetails, args);
    }
}

export class PersonRoleEdit extends PersonRoleBase {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonRoleStateStrings.Edit,
        Url: "/resources/personrole/edit/{personRoleId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Roles",
        StateString: PersonRoleStateStrings.Edit,
        Template: require("./personrole.edit.html"),
        AngularDependencies: PersonRoleBase.BaseAngularDependencies
    }

    constructor(...args: any[]) {
        super(false,() => {
        }, PersonRoleDetails, args);
    }
}

export class PersonRoleNew extends PersonRoleBase {

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: PersonRoleStateStrings.New,
        Url: "/resources/personrole/new/{personId:int}",
        HeaderText: "Resources &raquo; Persons &raquo; Roles",
        StateString: PersonRoleStateStrings.New,
        Template: require("./personrole.new.html"),
        AngularDependencies: PersonRoleBase.BaseAngularDependencies
    }

    constructor(...args: any[]) {
        super(true,() => {
        }, PersonRoleDetails, args);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/personrole/personrole.common.ts